import i18next from 'i18next'

import sv from './sv.json'
import en from './en.json'

i18next.init({
  lng: 'sv',
  debug: process.env.NODE_ENV !== 'production',
  resources: {
    en: {
      translation: en
    },
    sv: {
      translation: sv
    }
  }
})

export { i18next }
